import React from "react";
import {
    defineBlock,
    smartProps,
    EditableText,
    useEditor,
    useInspectorControl,
    useSmartProp,
    useToolbar,
} from '@smartfire/gutenberg-react';
import {
    PanelBody,
    PanelRow,
    TextControl,
    ToggleControl,
    Toolbar,
    ToolbarButton,
    ToolbarGroup,
    SelectControl,
} from '@wordpress/components';

import classnames from 'classnames';
import style from "./block.module.scss";
import clsx from "clsx";

const Inspector = () => {
    const [buttonUrl, setbuttonUrl] = useSmartProp('buttonUrl');
    const [buttonStyle, setButtonStyle] = useSmartProp('buttonStyle');
    const [blank, setBlank] = useSmartProp('blank');


    return (
        <>
            <PanelBody title="Lien" initialOpen={false} icon="admin-buttonUrls">
                <PanelRow>
                    <TextControl label="Lien" value={buttonUrl} onChange={setbuttonUrl} />
                </PanelRow>
                <PanelRow>
                    <ToggleControl label="Ouvrir dans un nouvel onglet" checked={blank} onChange={setBlank} />
                </PanelRow>
            </PanelBody>

            <PanelBody title="Styles" initialOpen={false}>
                <PanelRow>
                    <SelectControl
                        label="Style"
                        value={buttonStyle}
                        onChange={setButtonStyle}
                        options={[
                            { value: 'fill', label: 'Rempli', selected: true },
                            { value: 'outline', label: 'Inversé' },
                            { value: 'ghost', label: 'Transparent' }
                        ]}
                    />
                </PanelRow>
            </PanelBody>
        </>
    );
}

const BlockToolbar = () => {
    const [buttonPosition, setButtonPosition] = useSmartProp('buttonPosition');

    return (
        <Toolbar label="Options">
            <ToolbarGroup>
                <ToolbarButton
                    isPressed={buttonPosition === 'left'}
                    icon="align-left"
                    label="Gauche"
                    onClick={() => setButtonPosition('left')}
                />
                <ToolbarButton
                    isPressed={buttonPosition === 'center'}
                    icon="align-center"
                    label="Centre"
                    onClick={() => setButtonPosition('center')}
                />
                <ToolbarButton
                    isPressed={buttonPosition === 'right'}
                    icon="align-right"
                    label="Droite"
                    onClick={() => setButtonPosition('right')}
                />
            </ToolbarGroup>
        </Toolbar>
    );
}

const Block = ({ buttonText, buttonUrl, blank, buttonPosition, buttonStyle, external = false, className = null, picto = null, ...props }) => {
    const { isEditing } = useEditor();
    useInspectorControl(!external ? Inspector : () => '');
    useToolbar(!external ? BlockToolbar : () => '');

    // Classes for block
    const blockClasses = classnames({
        [style.block]: true,
        [style[buttonPosition]]: true,
    });

    // Classes for BTN
    const btnClasses = classnames({
        [style.buttonOss]: true,
        [style[buttonStyle]]: true, 
    });


    return (
        <div className={clsx(className, blockClasses)}>
            <a
                className={btnClasses}
                href={!isEditing && buttonUrl}
                target={blank && '_blank'}
                style={{cursor: isEditing ? "text" : "pointer"}}
                {...props}
            >
            {!external ? (
                <EditableText
                    smartProp="buttonText" 
                    tagName={"span"}
                    placeholder="Button"
                />
            ) : (
                <span className={clsx(picto && style.picto, picto && buttonText && style.text)}>{buttonText}{picto}</span>
            )}
            </a>
        </div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        buttonText: smartProps.string.withDefault(''),
        buttonUrl: smartProps.string.withDefault(''),
        buttonPosition: smartProps.string.withDefault('left'),
        buttonStyle: smartProps.string.withDefault('fill'),
        blank: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Bouton',
    }
});
